import { revalidatePath } from "@/lib/revalidate";

import { ApiError, addProgramme, createEvent } from "@/lib/api/client";

export type EventResult = { ok: true; code: string } | { ok: false; error: string };

export async function createEventAction(payload: {
  code: string;
  name: string;
  startDate?: string;
  endDate?: string;
}): Promise<EventResult> {
  try {
    const created = await createEvent(payload);
    revalidatePath("/events");
    return { ok: true, code: created.code };
  } catch (error) {
    const message = error instanceof ApiError ? error.message : "could not create the event";
    return { ok: false, error: message };
  }
}

/** Put a sport inside a Games. From here down it is an ordinary competition
 * tree, edited through that sport's own screens. */
export async function addProgrammeAction(
  code: string,
  sportCode: string,
  name: string,
  /** Which of the sport's top levels the programme is — a festival, a tour, a
   *  meet. Omitted when the sport declares only one and there is nothing to ask. */
  level?: string,
): Promise<EventResult> {
  try {
    await addProgramme(code, { sportCode, name, level });
    revalidatePath(`/events/${code}`);
    return { ok: true, code };
  } catch (error) {
    const message = error instanceof ApiError ? error.message : "could not add the sport";
    return { ok: false, error: message };
  }
}
